import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppExperiments, useIsTreatment } from '../../../../utils/experiments';
import { useRecentAuditEvents } from '../../../Activity/hooks/useRecentAuditEvents';
import { ROUTE_ACTIVITY } from '../../../Activity/utils/constants';

import { RecentActivitySection } from './RecentActivitySection';

type MemberRecentActivityProps = {
  organizationId: string;
  memberUuid: string;
};

export function MemberRecentActivity({ organizationId, memberUuid }: MemberRecentActivityProps) {
  const navigate = useNavigate();
  const isWorkspaceAuditLogTreatment = useIsTreatment(AppExperiments.t0018_aac156e2);

  const { rows, isLoading } = useRecentAuditEvents(
    isWorkspaceAuditLogTreatment ? organizationId : '',
    isWorkspaceAuditLogTreatment ? memberUuid : '',
  );

  const activityPath = useMemo(
    () => `${ROUTE_ACTIVITY}?actorId=${encodeURIComponent(memberUuid)}`,
    [memberUuid],
  );

  const handleViewAll = useCallback(() => {
    navigate(activityPath);
  }, [activityPath, navigate]);

  if (!isWorkspaceAuditLogTreatment) {
    return null;
  }

  return <RecentActivitySection rows={rows} isLoading={isLoading} onViewAll={handleViewAll} />;
}
